export default "__VITE_ASSET__BRkwbBau__"